var SCROLL_AMOUNT = 280;

// ── Lightbox ──
var lb, lbContent, lbImg, lbThumbs, lbCounter, lbPrev, lbNext, lbCloseBtn;
var gallery = [], curIdx = 0;

function lbUpdateCounter() {
  var n = gallery.length;
  lbCounter.textContent = n > 1 ? (curIdx + 1) + ' / ' + n : '';
}

function lbUpdateNav() {
  var show = gallery.length > 1 ? 'flex' : 'none';
  lbPrev.style.display = show;
  lbNext.style.display = show;
}

function lbUpdateThumbs() {
  Array.from(lbThumbs.children).forEach(function (t, i) {
    var active = i === curIdx;
    t.style.opacity = active ? '1' : '0.4';
    t.style.outlineColor = active ? 'rgba(255,255,255,0.85)' : 'transparent';
  });
  var active = lbThumbs.children[curIdx];
  if (active) active.scrollIntoView({ inline: 'nearest', block: 'nearest' });
}

function lbBuildThumbs() {
  lbThumbs.innerHTML = '';
  if (gallery.length <= 1) return;
  gallery.forEach(function (src, i) {
    var img = document.createElement('img');
    img.src = src; img.draggable = false;
    img.style.height = '44px'; img.style.width = '66px';
    img.style.objectFit = 'cover'; img.style.borderRadius = '4px';
    img.style.cursor = 'pointer'; img.style.flexShrink = '0';
    img.style.outline = '2px solid transparent'; img.style.outlineOffset = '2px';
    img.addEventListener('click', function (e) { e.stopPropagation(); lbNavigate(i); });
    lbThumbs.appendChild(img);
  });
  lbUpdateThumbs();
}

function lbNavigate(newIdx) {
  if (newIdx === curIdx) return;
  lbImg.style.opacity = '0';
  setTimeout(function () {
    curIdx = newIdx; lbImg.src = gallery[curIdx]; lbImg.style.opacity = '1';
    lbUpdateCounter(); lbUpdateThumbs();
  }, 150);
}

export function lbOpen(images, idx) {
  gallery = images; curIdx = idx;
  lbImg.style.opacity = '1'; lbImg.src = gallery[curIdx];
  lbBuildThumbs(); lbUpdateNav(); lbUpdateCounter();
  lb.style.opacity = '0'; lb.style.display = 'flex';
  requestAnimationFrame(function () { lb.style.opacity = '1'; });
  document.body.style.overflow = 'hidden';
}

function lbClose() {
  lb.style.opacity = '0';
  setTimeout(function () { lb.style.display = 'none'; lbImg.src = ''; lbThumbs.innerHTML = ''; }, 150);
  document.body.style.overflow = '';
}

export function initLightbox() {
  lb = document.getElementById('lightbox');
  if (!lb) return;
  lbContent = document.getElementById('lb-content');
  lbImg = document.getElementById('lb-img');
  lbThumbs = document.getElementById('lb-thumbs');
  lbCounter = document.getElementById('lb-counter');
  lbPrev = document.getElementById('lb-prev');
  lbNext = document.getElementById('lb-next');
  lbCloseBtn = document.getElementById('lb-close');

  lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
  lbContent.addEventListener('click', function (e) { e.stopPropagation(); });
  lbCloseBtn.addEventListener('click', function (e) { e.stopPropagation(); lbClose(); });
  lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbNavigate((curIdx - 1 + gallery.length) % gallery.length); });
  lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbNavigate((curIdx + 1) % gallery.length); });
  document.addEventListener('keydown', function (e) {
    if (lb.style.display !== 'flex') return;
    if (e.key === 'Escape') lbClose();
    if (e.key === 'ArrowLeft') lbNavigate((curIdx - 1 + gallery.length) % gallery.length);
    if (e.key === 'ArrowRight') lbNavigate((curIdx + 1) % gallery.length);
  });

  // Expose globally for inline onclick handlers in review images
  window.lbOpen = lbOpen;
}

export function initPhotoStrips() {
  document.querySelectorAll('.photo-strip').forEach(function (strip) {
    var wrap = strip.parentElement;
    var prev = wrap.querySelector('.strip-prev');
    var next = wrap.querySelector('.strip-next');

    function updateArrows() {
      var atStart = strip.scrollLeft < 2;
      var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      prev.style.display = atStart ? 'none' : 'flex';
      next.style.display = atEnd ? 'none' : 'flex';
    }
    updateArrows();
    strip.addEventListener('scroll', updateArrows);
    strip.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', updateArrows); });
    prev.addEventListener('click', function () { strip.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' }); });
    next.addEventListener('click', function () { strip.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' }); });

    var startX, startScroll, dragging = false, hasDragged = false;
    strip.addEventListener('mousedown', function (e) {
      e.preventDefault(); dragging = true; hasDragged = false;
      startX = e.pageX - strip.offsetLeft; startScroll = strip.scrollLeft;
      strip.classList.add('dragging');
    });
    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      var dx = (e.pageX - strip.offsetLeft) - startX;
      if (Math.abs(dx) > 4) hasDragged = true;
      strip.scrollLeft = startScroll - dx;
    });
    document.addEventListener('mouseup', function () { dragging = false; strip.classList.remove('dragging'); });

    strip.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (hasDragged) return;
        var liveLinks = Array.from(strip.querySelectorAll('a'));
        var idx = liveLinks.indexOf(link);
        if (idx === -1) return;
        lbOpen(liveLinks.map(function (a) { return a.href; }), idx);
      });
    });
  });
}
